import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const StyledNav = styled("nav")(
  ({ theme }) => `
  margin-top: ${theme.spacing(2)};
  margin-bottom: ${theme.spacing(3)};
`,
);

export const BreadCrumbsList = styled("ul")(
  ({ theme }) => `
  display: flex;
  padding-left: 0;
  margin-bottom: ${theme.spacing(2)};

  li {
    display: flex;
    flex-direction: row;
    list-style: none;
    margin-right: ${theme.spacing(1)};

    a {
      margin-right: ${theme.spacing(1)};
    }
  }
`,
);

export const BreadcrumbLink = styled(Link)`
  color: color-mix(in srgb, var(--foreground) 30%, var(--blue));
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;
